<template>
  <div :class="className" :style="{ height: eHeight, width: width }" />
</template>
<script>

import * as echarts from 'echarts'
require('echarts/theme/macarons') // echarts theme
import resize from './mixins/resize'
import fujian from '@/util/fujian.json';
import fuzhou from '@/util/fuzhou.json';
import jinan from '@/util/jinan.json';
let regionInfoJson = [
  {
    name: '福建省',
    mapId: '35',
    logogram: 'fujian',
    mapTypeJson: fujian
  },
  {
    name: '福州市',
    mapId: '3501',
    logogram: 'fuzhou',
    mapTypeJson: fuzhou
  },
  {
    name: '晋安区',
    mapId: '350111',
    logogram: 'jinan',
    mapTypeJson: jinan
  }
]

let data1 = [
  { name: '漳州市', value: 20057, follow: 123, age1: 123, age2: 123, age3: 123, age4: 123 },
  { name: '厦门市', value: 15477, follow: 123, age1: 123, age2: 123, age3: 123, age4: 123 },
  { name: '泉州市', value: 31686, follow: 123, age1: 123, age2: 123, age3: 123, age4: 123 },
  { name: '莆田市', value: 6992, follow: 123, age1: 123, age2: 123, age3: 123, age4: 123 },
  { name: '福州市', value: 44045, follow: 4543, age1: 123, age2: 123, age3: 123, age4: 123 },
  { name: '宁德市', value: 40689, follow: 123, age1: 123, age2: 123, age3: 123, age4: 123 },
  { name: '三明市', value: 37659, follow: 123, age1: 123, age2: 123, age3: 123, age4: 123 },
  { name: '龙岩市', value: 45180, follow: 123, age1: 123, age2: 123, age3: 123, age4: 123 },
  { name: '南平市', value: 55204, follow: 123, age1: 123, age2: 123, age3: 123, age4: 123 },
]

let data2 = [
  { name: '鼓楼区', value: 20057, follow: 123, age1: 123, age2: 123, age3: 123, age4: 123 },
  { name: '台江区', value: 15477, follow: 123, age1: 123, age2: 123, age3: 123, age4: 123 },
  { name: '仓山区', value: 31686, follow: 123, age1: 123, age2: 123, age3: 123, age4: 123 },
  { name: '马尾区', value: 6992, follow: 123, age1: 123, age2: 123, age3: 123, age4: 123 },
  { name: '晋安区', value: 1865, follow: 100, age1: 6193, age2: 70, age3: 2482, age4: 30 },
  { name: '长乐区', value: 40689, follow: 123, age1: 123, age2: 123, age3: 123, age4: 123 },
  { name: '闽侯县', value: 37659, follow: 123, age1: 123, age2: 123, age3: 123, age4: 123 },
  { name: '平潭县', value: 45180, follow: 123, age1: 123, age2: 123, age3: 123, age4: 123 },
  { name: '福清市', value: 55204, follow: 123, age1: 123, age2: 123, age3: 123, age4: 123 },
  { name: '连江县', value: 55204, follow: 123, age1: 123, age2: 123, age3: 123, age4: 123 },
  { name: '闽清县', value: 55204, follow: 123, age1: 123, age2: 123, age3: 123, age4: 123 },
  { name: '永泰县', value: 55204, follow: 123, age1: 123, age2: 123, age3: 123, age4: 123 },
  { name: '罗源县', value: 55204, follow: 123, age1: 123, age2: 123, age3: 123, age4: 123 },
]

let data3 = [
  { name: '王庄街道', value: 1607, follow: 10, age1: 1000, age2: 8, age3: 607, age4: 2 },
  { name: '象园街道', value: 4981, follow: 5, age1: 3505, age2: 4, age3: 1476, age4: 1 },
  { name: '鼓山镇', value: 22215, follow: 5, age1: 1600, age2: 5, age3: 6215, age4: 0 },
  { name: '日溪乡', value: 340, follow: 10, age1: 180, age2: 9, age3: 120, age4: 1 },
  { name: '寿山乡', value: 104, follow: 10, age1: 85, age2: 6, age3: 19, age4: 4 },
  { name: '新店镇', value: 20173, follow: 13, age1: 12500, age2: 8, age3: 7673, age4: 5 },
  { name: '宦溪镇', value: 504, follow: 10, age1: 304, age2: 5, age3: 200, age4: 5 },
  { name: '岳峰镇', value: 8452, follow: 12, age1: 5605, age2: 6, age3: 2847, age4: 6 },
  { name: '茶园街道', value: 4080, follow: 15, age1: 2585, age2: 9, age3: 1495, age4: 6 }
]



export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    eHeight: {
      type: String,
      default: '100%'
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    chartData: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      chart: null,
      mapJson: {},
      mapParentJson: ""
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val)
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.chart = echarts.init(this.$el, 'macarons')
    })
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    // 加载地图数据
    initChart(data, verify) {
      if (verify) {
        this.mapJson = data;
      }
      this.chart.dispose()
      this.chart = null
      this.chart = echarts.init(this.$el, 'macarons')
      for (var key in regionInfoJson) {
        if (regionInfoJson[key].name === data.name) {
          data.logogram = regionInfoJson[key].logogram
          echarts.registerMap(data.logogram, regionInfoJson[key].mapTypeJson);
          break;
        }
      }
      this.setOptions(data || {})
    },
    // 进入下级地图(记录)
    switchoverMap(data) {
      this.mapParentJson = data;
      this.initChart(data, false);
      this.$emit('watchChild',data);
    },
    // 返回上级地图
    returnMap() {
      if(this.mapParentJson.id.length <= 2){
        return;
      }
      this.mapBtnList(this.mapJson);
      this.switchoverMap(this.mapParentJson);
    },
    // 递归方法判断上级地图数据
    mapBtnList(data) {
      if (data.children != undefined) {
        for (var key in data.children) {
          // console.log("进入" + data.children[key].name + "/id:" + data.children[key].id+ "指定id:" + this.mapParentJson.id);
          if (data.children[key].id === this.mapParentJson.id) {
            // console.log("正常");
            this.mapParentJson = data;
            break;
          }
          if (data.children[key].children != undefined) {
            this.mapBtnList(data.children[key]);
          }
        }
        
      }
    },
    setOptions(data) {
      console.log("地图数据",data);
      let _this = this;
      _this.option = {
        tooltip: {
          trigger: 'item',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          },
          enterable: true, // 鼠标是否可进入提示框浮层中
          hideDelay: 200, // 浮层隐藏的延迟
          confine: true,
          padding: 0,
          backgroundColor: 'rgba(255,255,255, 1)',
          formatter: function (params) {
            var htmlStr = '<div style="height: auto;max-height: 340px; width:250px;overflow-y: auto;color:#000;line-height:1;font-size:14px">'
            htmlStr += '<div style="text-align:center;padding:15px 0;font-size:16px;font-weight:bold;">' + params.name + '</div>'
            htmlStr += '<div style="display:flex;align-items: center;justify-content: space-between;padding:12px 16px;font-size:14px;border-bottom:1px solid #DCDCDC"><div>青少年总数：</div><div>' + params.data.amount + '</div></div>'
            htmlStr += '<div style="display:flex;align-items: center;justify-content: space-between;padding:12px 16px;font-size:14px;border-bottom:1px solid #DCDCDC"><div>重点关注：</div><div>' + params.data.refAmount + '</div></div>'
            htmlStr += '<div style="padding:5px 16px">'
            // htmlStr += '<div style="padding-bottom:10px;border-bottom:1px dotted #DCDCDC;color:#25282C;"><div style="font-size:14px;color:#25282C;margin:10px 0 15px;">颜色标注</div>'

            // htmlStr += '<div style="display:flex;align-items: center;justify-content: space-between;"><div><span style="display:inline-block;width: 10px;height: 10px;background: #FF2323;border-radius:50%;margin-right:5px"></span>10</div><div><span style="display:inline-block;width: 10px;height: 10px;background: #127AFF;border-radius:50%;margin-right:5px"></span>10</div><div><span style="display:inline-block;width: 10px;height: 10px;background: #3BD413;border-radius:50%;margin-right:5px"></span>10</div></div></div>'


            htmlStr += '<div style="padding-bottom:10px;border-bottom:1px dotted #DCDCDC;color:#25282C;"><div style="font-size:14px;color:#25282C;margin:10px 0 15px;">年龄段</div>'

            // 年龄段
            htmlStr += '<div style="display:flex;align-items: center;justify-content: space-between; line-height:1.4;padding:5px 0"><div style="color:#909090">未成年(5-18)</div><div>' + params.data.underage + '人</div></div>'
            htmlStr += '<div style="display:flex;align-items: center;justify-content: space-between; line-height:1.4;padding:5px 0"><div style="color:#909090">涉案人数(5-18)</div><div>' + params.data.refUnderage + '人</div></div>'
            htmlStr += '<div style="display:flex;align-items: center;justify-content: space-between; line-height:1.4;padding:5px 0"><div style="color:#909090">成年(18-25)</div><div>' + params.data.adult + '人</div></div>'
            htmlStr += '<div style="display:flex;align-items: center;justify-content: space-between; line-height:1.4;padding:5px 0"><div style="color:#909090">涉案人数(18-25)</div><div>' + params.data.refAdult + '人</div></div>'

            htmlStr += '</div>'
            htmlStr += '</div></div>'
            return htmlStr
          },
          extraCssText: 'box-shadow: 0 0 3px rgba(150,150,150, 0.7);',
          textStyle: {
            fontSize: 12,
            color: '#fff'
          }
        },
        series: [{
          name: '福建呼叫实时情况',
          type: 'map',
          mapType: data.logogram, // 自定义扩展图表类型
          label: {
            show: true,
            color: '#fff',
            lineHeight: 16,
            // formatter: '{b}\n青少年总量:86015\n重点关注:100'
            formatter: function (x) {
              // console.log(x)
              return x.name + '\n青少年总量：' + x.data.amount + '\n重点关注：' + x.data.refAmount
            }
          },
          itemStyle: {
            areaColor: _this.isbig ? '#4AB0E8' : '#9933ff'
          },
          data: data.children
          // 自定义名称映射
        }]
      }
      _this.chart.setOption(_this.option);
      _this.chart.on('click', function (params) {
        // console.log(params);
        if (params.data.id == "3501") {
          // 如果是福州的话的 展示下级
          // echarts.registerMap('fuzhou', fuzhou);
          // _this.option.series[0].mapType = 'fuzhou';
          // _this.option.series[0].data = data2;
          // _this.chart.setOption(_this.option);
          _this.switchoverMap(params.data);
          // _this.initChart(params.data,false);
        }
        if (params.data.id == "350111") {
          // 如果是晋安的话的 展示下级
          // echarts.registerMap('jinan', jinan);
          // _this.option.series[0].mapType = 'jinan';
          // _this.option.series[0].data = data3;
          // _this.chart.setOption(_this.option);
          _this.switchoverMap(params.data);
          // _this.initChart(params.data,false);
        }
      })
    },

  }
}

</script>
